var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-info font-weight-bold"},[_vm._v(" Downloading "+_vm._s(_vm.downloadedCount)+"/"+_vm._s(_vm.downloadFileCount)+" files... ")]),_c('CProgress',{staticClass:"mt-1"},[_c('CProgressBar',{attrs:{"color":"info","value":_vm.downloadProgress,"animated":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }